import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { InquiryModal, RiderNotAvailableModal } from '../../../../components';
import { isLocalhost } from '../../../../util/urlHelpers';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { sendEnquiry } from '../../ListingPage.duck';
import { queryRiderListing } from '../../../../ducks/riderListings.duck';
import {
    ERROR_INQUIRY_DISABLED_FOR_RIDER_NOT_AVAILABLE,
    ERROR_INQUIRY_DISABLED_FOR_RIDER_PROFILE_INCOMPLETE,
} from '../../../../components/InquiryModal/InquiryModal.helpers';
import { useContext } from 'react';
import { ListingPageContext } from '../../ListingPage';
import { ensureCurrentUser, ensureUser } from '../../../../util/data';
import { trimDisplayNameLastWord } from '../../../../util/text';

const windowDefined = typeof window !== 'undefined';

export const SectionInquiry = ({ currentListing }) => {
    const { inquiryModalOpen, setInquiryModalOpen } = useContext(ListingPageContext);
    const history = useHistory();
    const dispatch = useDispatch();

    const listingAuthor = useSelector(s => s.ListingPage.listingAuthor);
    const currentUser = useSelector(s => s.user.currentUser);
    const sendEnquiryError = useSelector(s => s.ListingPage.sendEnquiryError);

    const [riderNotAvailableStatus, setRiderNotAvailableStatus] = useState(null);

    const onSendEnquiry = values => dispatch(sendEnquiry(values));

    const authorId = listingAuthor?.id?.uuid;
    const currentUserId = currentUser?.id?.uuid;
    const isOwnListing = currentUserId && authorId && authorId === currentUserId;
    const userIsCurrentUser = listingAuthor && listingAuthor.type === 'currentUser';

    const ensuredUser = userIsCurrentUser
        ? ensureCurrentUser(listingAuthor)
        : ensureUser(listingAuthor);

    const { displayName } = ensuredUser.attributes.profile;
    const authorDisplayName = trimDisplayNameLastWord(displayName);

    const onSubmitEnquiry = async values => {
        const txId = await onSendEnquiry(values);

        if (txId && txId.uuid) {
            setInquiryModalOpen(false);

            history.push(
                createResourceLocatorString(
                    'OrderDetailsPage',
                    routeConfiguration(),
                    { id: txId.uuid },
                    {}
                )
            );
        }
    };

    const onSubmitEnquiryDecorator = values => {
        if (isLocalhost()) return onSubmitEnquiry(values);

        // reCAPTCHA may be not loaded (ad blockers, declined consent, network errors)
        if (windowDefined && window.checkRecaptchaBeforeSubmit) {
            window.checkRecaptchaBeforeSubmit(() => onSubmitEnquiry(values));
        } else {
            onSubmitEnquiry(values);
        }
    };

    const handleInquiryError = code => {
        if (
            code === ERROR_INQUIRY_DISABLED_FOR_RIDER_PROFILE_INCOMPLETE ||
            code === ERROR_INQUIRY_DISABLED_FOR_RIDER_NOT_AVAILABLE
        ) {
            setInquiryModalOpen(false);
            setRiderNotAvailableStatus(code);
        }
    };

    return (
        <>
            {inquiryModalOpen && (
                <InquiryModal
                    isOpen
                    initialListing={currentListing}
                    publicUser={listingAuthor}
                    sendEnquiryError={sendEnquiryError}
                    ridingListingAuthorId={isOwnListing || !currentUserId ? null : currentUserId}
                    onSendEnquiry={values => onSubmitEnquiryDecorator(values)}
                    onClose={() => setInquiryModalOpen(false)}
                    notifyOnError={handleInquiryError}
                />
            )}
            {!!riderNotAvailableStatus && (
                <RiderNotAvailableModal
                    isOpen
                    onClose={() => setRiderNotAvailableStatus(null)}
                    horseownerName={authorDisplayName}
                    riderNotAvailableStatus={riderNotAvailableStatus}
                    notifyOnAvailabilityChange={() => {
                        /** the backend has re-opened the rider listing; refresh the stored copy */
                        dispatch(queryRiderListing(currentUserId, { force: true }));
                        setRiderNotAvailableStatus(null);
                    }}
                />
            )}
        </>
    );
};
